import {spawnErrorToast} from '@hm/fundamental'
import {AxiosError} from 'axios'
import {useTranslation} from 'react-i18next'

import {useRefraQuery} from '@refra/modules/common/hooks'
import {ErrorResponse} from '@refra/modules/common/types'
import {logger} from '@refra/modules/common/utils'

interface useDrillingSettingsQueryParams {
  plantUpmId: string
  kilnUpmId: string
}

export const useDrillingSettingsQuery = ({
  plantUpmId,
  kilnUpmId
}: useDrillingSettingsQueryParams) => {
  const {t} = useTranslation()

  return useRefraQuery({
    queryKey: 'drillingSettings',
    params: [{plantUpmId, kilnUpmId}],
    throwOnError: (error) => {
      const axiosError = error as AxiosError<ErrorResponse>
      const errorDetails =
        axiosError?.response?.data.detail ?? axiosError.message ?? axiosError.response?.status
      logger
        .context('useDrillingSettingsQuery')
        .extras({errorDetails, plantUpmId, kilnUpmId})
        .error('Error occurred while fetching drilling settings')

      spawnErrorToast(t('error.drillingSettingsQuery'))

      return false
    }
  })
}
